function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26 10H82C84.2091 10 86 11.7909 86 14V54H26V10Z",
  fill: "#D8DDEB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M11 14C11 11.7909 12.7909 10 15 10H62C64.2091 10 66 11.7909 66 14V54H11V14Z",
  fill: "#EAEEF4"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  y: 54,
  width: 100,
  height: 4,
  rx: 2,
  fill: "#F5F8FA"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 26,
  y: 25,
  width: 24,
  height: 14,
  rx: 4,
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 30,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 34,
  y: 28,
  width: 4,
  height: 8,
  rx: 2,
  fill: "#D8DDEB"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  x: 44,
  y: 28,
  width: 2,
  height: 8,
  rx: 1,
  fill: "#D8DDEB"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M83.3968 1.68441C84.7579 -0.56147 88.2421 -0.56147 89.6033 1.68441L99.5376 18.0755C100.873 20.2783 99.1575 23 96.4343 23H76.5657C73.8425 23 72.1274 20.2783 73.4624 18.0755L83.3968 1.68441ZM88.28 18.0435C88.28 18.956 87.483 19.6957 86.4998 19.6957C85.5166 19.6957 84.7196 18.956 84.7196 18.0435C84.7196 17.1309 85.5166 16.3912 86.4998 16.3912C87.483 16.3912 88.28 17.1309 88.28 18.0435ZM86.4998 4.8256C85.5166 4.8256 84.7196 5.56534 84.7196 6.47784V11.4345C84.7196 12.347 85.5166 13.0868 86.4998 13.0868C87.483 13.0868 88.28 12.347 88.28 11.4345V6.47784C88.28 5.56534 87.483 4.8256 86.4998 4.8256Z",
  fill: "url(#paint0_linear)"
});

var _ref11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 59.5,
  y1: 11.5,
  x2: 82.2075,
  y2: 38.1566,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#00BAFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#007CFF"
})));

function SvgPackageWithWarningTriangle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 58,
    viewBox: "0 0 100 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
}

var ForwardRef = React.forwardRef(SvgPackageWithWarningTriangle);
export default __webpack_public_path__ + "static/media/package-with-warning-triangle.f8059602.svg";
export { ForwardRef as ReactComponent };